import React, { useState } from "react";
import axios from "axios";
import API_ENDPOINT from "../wm.api.service";
import "./login.css";
import Wmbutton from "../ui-components/wm-button/Wm.button";
import Wminput from "../ui-components/wm-form-components/input/Wm.input";
import logo from "../assets/images/logo2.svg";
import { useHistory } from "react-router-dom";
import eye from "../assets/images/eye.png";
import hide from "../assets/images/noteye.png";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import ReCAPTCHA from "react-google-recaptcha";
function Resetpassword() {
  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }
  const history = useHistory();
  const [isResetSuccess, setIsResetSuccess] = useState(false);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setErrorMessage] = useState("");
  const urls = new URLSearchParams(window.location.search);
  const code = urls.get("reset_code");
  const [captaToken, setCaptaToken] = useState("");
  function onChange(value) {
    setCaptaToken(value);
    setErrorMessage("");
  }
  const resetPassword = (e) => {
    if (captaToken) {
      setIsLoading(true);
      e.preventDefault();
      var fd = new FormData();
      fd.append("new_pass", password);
      fd.append("new_confirm_pass", confirmPassword);
      fd.append("code", code);
      axios({
        method: "POST",
        url: `${API_ENDPOINT.apiURL}Authentication/resetPassword`,
        data: fd,
      })
        .then((response) => {
          setIsLoading(false);
          setIsResetSuccess(true);
          history.replace("/login");
        })
        .catch((err) => {
          setIsLoading(false);
          setErrorMessage(err.response.data.message);
        });
    } else {
      setErrorMessage("Please Solve The reCaptcha");
    }
  };
  const [showPassword, setShowPassword] = useState(false);
  const userPage = () => {
    history.replace("/forgotpassword");
  };
  return (
    <>
      {code ? (
        <>
          <div className="loginBg resetBG_img py-5">
            <div className="login">
              <div className="flex justify-center mb-4">
                <img src={logo} alt="logo" className="w-48" />
              </div>
              <div className="login_container">
                <div className="wm-form-group flex flex-col mb-3">
                  <label htmlFor="First name" className="text-sm">
                    New Password
                  </label>
                  <div className="flex border-b border-gray-300 border-solid">
                    <Wminput type={`${showPassword ? "text" : "password"}`} name="password_login" className="border-0 flex-1" onChange={(e) => setPassword(e.target.value)}/>
                    <img src={showPassword ? eye : hide} alt="eye" className="w-7 cursor-pointer" onClick={() => setShowPassword(!showPassword)}/>
                  </div>
                </div>
                <div className="wm-form-group flex flex-col mb-3">
                  <label htmlFor="First name" className="text-sm">
                    Confirm New Password
                  </label>
                  <div className="flex border-b border-gray-300 border-solid">
                    <Wminput type={`${showPassword ? "text" : "password"}`} name="password_login" className="border-0 flex-1" onChange={(e) => setConfirmPassword(e.target.value)}/>
                    <img src={showPassword ? eye : hide} alt="eye" className="w-7 cursor-pointer" onClick={() => setShowPassword(!showPassword)}/>
                  </div>
                </div>
                <div className="text-center w-full flex items-center justify-center mb-2">
                  <ReCAPTCHA sitekey="6LerMHIcAAAAAOUy6oJG2xt0SDTuSVoNbPX4K4w3" onChange={onChange}/>
                </div>
                <div className="text-center mb-3">
                  {error && <span className="text-red-600 text-xs">{error}</span>}
                </div>
                <div className="wm-form-group flex mb-4">
                  <Wmbutton className="h-10 login-btn" label={`${isLoading ? "Loading..." : "Reset Password"}`} type="submit" color="primary" onClick={(e) => resetPassword(e)}/>
                </div>
              </div>
            </div>
          </div>
          <Snackbar anchorOrigin={{ vertical: "top", horizontal: "right" }} open={isResetSuccess} autoHideDuration={6000} onClose={() => setIsResetSuccess(false)} className="toastSuccess">
            <Alert onClose={() => setIsResetSuccess(false)}>
              Password Has Been Changed Succesfully
            </Alert>
          </Snackbar>
        </>
      ) : (
        userPage()
      )}
    </>
  );
}

export default Resetpassword;
